import { MouseEventHandler } from "react";
import { Button, Icon, Box } from "@bca/ui-library";
import css from "@styled-system/css";
import styled from "styled-components";

import media from "../media";

const StyledBox = styled(Box)`
  display: none;
  ${media.mobile} {
    display: block;
  }
`;

const TrackButtonMobile: React.FunctionComponent<{
  isTracked: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ isTracked, onClick }) => {
  return (
    <StyledBox mr={3} data-testid="mobile-track-container">
      <Button
        variant="secondary-white"
        padding="10px"
        height="auto"
        width="auto"
        onClick={onClick}
        css={`
          ${css({
            borderColor: isTracked ? "secondary-orange" : "primary-white",
          })}
        `}
        title={isTracked ? "Remove Tracking" : "Track"}
      >
        <Icon
          width="21px"
          height="21px"
          name="star"
          weight={isTracked ? "solid" : "light"}
          color={isTracked ? "secondary-orange" : "primary-white"}
        ></Icon>
      </Button>
    </StyledBox>
  );
};

export default TrackButtonMobile;
